import { queryOptions, useQuery } from "@tanstack/react-query";
import type { ActiveBannersResponse } from "@godalming/api-types";
import { getActiveBanners } from "./api";

export const activeBannersQueryOptions = () =>
    queryOptions<ActiveBannersResponse>({
        queryKey: ["banner", "active"],
        queryFn: getActiveBanners,
    });

export function useActiveBannersQuery() {
    return useQuery(activeBannersQueryOptions());
}
